import React from 'react';
import { useNavigate } from 'react-router-dom';
import { statePaths } from './USAMapPaths';

interface StateData {
  id: string;
  name: string;
  citiesCount: number;
}

interface USAMapProps {
  states: StateData[];
  selectedState?: string;
  onStateClick: (stateCode: string) => void;
}

export function USAMap({ states, selectedState, onStateClick }: USAMapProps) {
  // Get count range for color scaling
  const counts = states.map(s => s.citiesCount);
  console.log('USAMap states:', states);
  console.log('State counts:', counts);
  
  const getStateColor = (count: number) => {
    if (count === 0) return '#f3f4f6';  // No coverage - Gray
    if (count >= 500) return '#0ea5e9'; // 50+ areas - Light blue
    if (count >= 250) return '#0284c7'; // 25-49 areas - Medium blue
    return '#075985';                  // 1-24 areas - Dark blue
  };

  const getStateTooltip = (stateCode: string) => {
    const stateData = states.find(s => s.id === stateCode);
    if (!stateData) return `${stateCode} - No coverage yet`;
    return `${stateData.name} - ${stateData.citiesCount} service area${stateData.citiesCount !== 1 ? 's' : ''}`;
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <svg
        viewBox="0 0 959 593"
        className="w-full h-full"
        role="img"
        aria-label="USA Map showing plumbing service coverage"
      >
        <title>USA Service Coverage Map</title>
        <g>
          {Object.entries(statePaths).map(([stateCode, path]) => {
            const stateData = states.find(s => s.id === stateCode);
            console.log(`State ${stateCode}:`, stateData);
            const hasService = stateData && stateData.citiesCount > 0;
            
            return (
              <path
                key={stateCode}
                d={path}
                id={stateCode}
                className={`transition-all duration-200 ${
                  hasService ? 'cursor-pointer hover:brightness-110' : 'cursor-not-allowed'
                } ${selectedState === stateCode ? 'stroke-blue-600 stroke-2' : 'stroke-gray-300'}`}
                fill={getStateColor(stateData?.citiesCount || 0)}
                onClick={() => hasService && onStateClick(stateCode)}
              >
                <title>{getStateTooltip(stateCode)}</title>
              </path>
            );
          })}
        </g>
      </svg>

      {/* Legend */}
      <div className="space-y-4">
        <div className="flex items-center justify-center space-x-8 text-sm text-gray-600">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-[#f3f4f6] mr-2"></div>
            <span>No coverage</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-[#075985] mr-2"></div>
            <span>1-24 areas</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-[#0284c7] mr-2"></div>
            <span>25-49 areas</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-[#0ea5e9] mr-2"></div>
            <span>50+ areas</span>
          </div>
        </div>
        <div className="text-center text-sm text-gray-600">
          Click on a state to view service areas
        </div>
      </div>
    </div>
  );
}